import classNames from 'classnames';

type LoaderProps = {
  className?: string;
};

export default function Loader({ className }: LoaderProps) {
  return (
    <div
      className={classNames(
        className,
        'loader-square-container mx-auto my-auto'
      )}
    >
      <div className="loader-square loader-square-cyan"></div>
      <div className="loader-square loader-square-purple"></div>
    </div>
  );
}
